import React from 'react';
import { InboxOutlined } from '@ant-design/icons';
import { Upload as UploadAntd, UploadProps } from 'antd';
import type { UploadChangeParam, UploadFile } from 'antd/lib/upload/interface';
import Button from '../../../Button/Button';
import formStyles from '../../shared/Form.module.scss';

export interface Props extends Omit<UploadProps, 'name' | 'onChange'> {
  label?: string | React.ReactNode;
  cta?: string;
  placeholder?: string;
  'data-testid'?: string;
  trailer?: React.ReactNode;
  error?: boolean;
  value?: UploadFile<File>[];
  onChange?(fileList: UploadFile<File>[]): void;
  draggable?: boolean;
  uploadText?: string;
}
const Upload: React.FC<Props> = ({
  label,
  cta = 'Browse',
  placeholder,
  disabled,
  trailer,
  onChange,
  value,
  accept,
  draggable = false,
  uploadText = 'Click or drag files to this area to upload',
  ...rest
}) => {
  const [selectedFiles, setSelectedFiles] = React.useState<UploadFile<File>[]>(
    []
  );
  const onChangeWrapper = React.useCallback(
    (uploadFileInfo: UploadChangeParam<UploadFile<File>>) => {
      if (
        accept &&
        uploadFileInfo.file.type &&
        !accept.includes(uploadFileInfo.file.type)
      ) {
        return;
      }

      setSelectedFiles(uploadFileInfo.fileList);
      onChange?.(uploadFileInfo.fileList);
    },
    [setSelectedFiles, onChange, accept]
  );

  return (
    <div className={formStyles.field}>
      <div className={formStyles.control}>
        {label && <label className={formStyles.label}>{label}</label>}
        {draggable ? (
          <UploadAntd.Dragger
            {...rest}
            accept={accept}
            disabled={disabled}
            onChange={onChangeWrapper}
            // ignore XHR
            beforeUpload={() => false}
          >
            <p className="ant-upload-drag-icon">
              <InboxOutlined />
            </p>
            <p className="ant-upload-text">{uploadText}</p>
          </UploadAntd.Dragger>
        ) : (
          <UploadAntd
            {...rest}
            accept={accept}
            disabled={disabled}
            onChange={onChangeWrapper}
            // ignore XHR
            beforeUpload={() => false}
          >
            <Button disabled={disabled}>{cta}</Button>
            {!selectedFiles.length && placeholder && (
              <span> {placeholder}</span>
            )}
          </UploadAntd>
        )}
      </div>

      {trailer}
    </div>
  );
};

export default Upload;
